/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useFormContext } from '@jalik/react-form'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import {
  TYPE_APARTMENT,
  TYPE_COMMERCIAL_PREMISE,
  TYPE_HOUSE,
  TYPE_TERRAIN
} from '../../enums/EstateTypeCodes.mjs'
import { FormRadioFieldProps } from '../../../../client/js/components/form/fields/FormField'
import { Checkbox, Stack } from '@mantine/core'

function EstateTypesField (props: FormRadioFieldProps) {
  const { name = 'types', ...others } = props
  const intl = useIntl()
  const form = useFormContext<Prospecting>()
  const { errors, getFieldProps, getValue, setValue } = form

  const handleChange = useCallback((values: string[]) => {
    setValue(name, values.map((estateType) => ({
      estateType,
      prospectingId: getValue('id')
    })))
  }, [getValue, name, setValue])

  const fieldProps = getFieldProps(name, others)

  const value = (getValue<ProspectingAndEstateType[]>(name) ?? []).map(({ estateType }) => estateType)

  return (
    <Checkbox.Group
      error={errors[name]?.message}
      label={intl.formatMessage({
        id: 'type',
        defaultMessage: 'Type'
      })}
      {...fieldProps}
      onChange={handleChange}
      value={value}
    >
      <Stack gap="xs">
        <Checkbox
          label={intl.formatMessage({
            id: 'apartment',
            defaultMessage: 'Appartement'
          })}
          value={TYPE_APARTMENT}
        />
        <Checkbox
          label={intl.formatMessage({
            id: 'house',
            defaultMessage: 'Maison'
          })}
          value={TYPE_HOUSE}
        />
        <Checkbox
          label={intl.formatMessage({
            id: 'commercial_premise',
            defaultMessage: 'Local'
          })}
          value={TYPE_COMMERCIAL_PREMISE}
        />
        <Checkbox
          label={intl.formatMessage({
            id: 'terrain',
            defaultMessage: 'Terrain'
          })}
          value={TYPE_TERRAIN}
        />
      </Stack>
    </Checkbox.Group>
  )
}

export default EstateTypesField
